import React from "react";
import Image from "../../Elements/Image/Image.tsx";
import logger from "../../../utils/logger.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import audioTimeViewTransfrom from "../../../utils/audioTimeViewTransfrom.js";
import VideoComponent from "./VideoElement.jsx";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import { useMailView } from "../../../contexts/mailViewContext/mailViewContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import useAudioControls, {
  TimeLine,
  VolumeBar,
} from "../../../hooks/useAudioControls.js";

import "./FilesTypeElement.scss";

const ImageGridElement = ({ item, inFeed }) => {
  const widthCondition = false;
  const heightCondition = false;
  const style = () => {
    if (widthCondition && heightCondition) {
      return { width: "unset", height: "unset" };
    }
    if (widthCondition) {
      return { width: "unset" };
    }
    if (heightCondition) {
      return { height: "unset" };
    }
    return {};
  };
  return (
    <Image
      src={inFeed ? item.PreviewSrc : item.ThumbSrc}
      style={style()}
      alt={item.Name}
    />
  );
};

const AudioGridElement = ({ children, item }) => {
  const { getPaymentData } = useMail();
  const {
    audioRef,
    play,
    currentTime,
    duration,
    progress,
    handleSeek,
    volume,
    setVolume,
    setDuration,
    handleClickIcon,
  } = useAudioControls({ item });

  return getPaymentData() ? (
    <div className="square-box">
      <div className="doc-box">
        <Icon name="music-note" gray />
      </div>
    </div>
  ) : (
    <div className="media-box">
      <audio
        controls={false}
        src={item.PreviewSrc}
        ref={audioRef}
        onLoadedData={() => {
          setDuration(audioRef.current.duration);
        }}
      />
      <div className="play-icon">
        <div className="circle-icon-box">
          <Icon
            name={play ? "pause_icon" : "play"}
            gray
            onClick={handleClickIcon}
          />
        </div>
        {play ? (
          <div className="audio-progress-bar">
            <div className="audio-timing">
              {audioTimeViewTransfrom(currentTime)}
            </div>
            <TimeLine {...{ progress, handleSeek }} />
            <div className="audio-timing">
              {audioTimeViewTransfrom(duration)}
            </div>
            <VolumeBar {...{ volume, setVolume, handleSeek }} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const VideoGridElement = ({ children, imageSrc, itemId }) => {
  const { getMobileGridView } = useMailView();
  const { mobileCondition } = useMediaQueries();
  return !getMobileGridView() && mobileCondition ? (
    <VideoComponent id={itemId} feedView={true} />
  ) : (
    <div className="media-box">
      <div className="play-icon video-play-icon">
        <Icon name="play" white />
      </div>
      <Image src={imageSrc} />
    </div>
  );
};

export const DefaultGridElement = ({ ext }) => (
  <div className="square-box">
    <div className="doc-box">
      <Icon name="file" gray />
    </div>
    {ext ? (
      <div className="file-extension">
        <span>{ext}</span>
      </div>
    ) : null}
  </div>
);

// here is we gonna use ENUM composition for rendering different types of files inside
const FileTypeGridElements = (obj, itemId, inFeed) => {
  if (!obj) {
    logger("FilesTypeElement", "obj is null", "this should not happen");
    return null;
  }
  const fileType = obj.Type ? obj.Type.toLowerCase() : null;
  // const detectNotValidSafari =
  //   navigator.userAgent.indexOf("Version/") > -1 &&
  //   navigator.userAgent.indexOf("Safari/") > -1 &&
  //   navigator.userAgent.split("Version/")[1].split(" ")[0].indexOf("14") === -1;

  const elems = {
    image: obj.ThumbSrc ? (
      <ImageGridElement item={obj} inFeed={inFeed} />
    ) : (
      <DefaultGridElement ext={obj.Extention} />
    ),
    audio: <AudioGridElement item={obj} />,
    video: obj.ThumbSrc ? (
      <VideoGridElement imageSrc={obj.ThumbSrc} itemId={itemId} />
    ) : (
      <DefaultGridElement ext={obj.Extention} />
    ),
    default: <DefaultGridElement ext={obj.Extention} />,
  };
  return elems[fileType] || elems.default;
};

FileTypeGridElements.defaultProps = {
  Type: "default",
  ThumbSrc: "no-data",
};

export default FileTypeGridElements;
